import * as React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '../../theme';
import { SidebarItem } from '../../routes';
import { observer } from 'mobx-react';
import { css } from '@emotion/react';

export interface SidebarItemWidgetProps {
  item: SidebarItem;
  active: boolean;
}

export const SidebarItemWidget: React.FC<SidebarItemWidgetProps> = observer((props) => {
  const { item, active } = props;

  const widget = (
    <S.SidebarItem disabled={!!item.disabled} active={active}>
      <S.Label disabled={!!item.disabled} active={active}>
        {item.label}
      </S.Label>
    </S.SidebarItem>
  );

  if (item.disabled) {
    return widget;
  }

  return <Link to={item.path}>{widget}</Link>;
});

export interface SidebarWidgetProps {
  items: SidebarItem[];
  activeItemKey?: string;
}

export const SidebarWidget: React.FC<SidebarWidgetProps> = (props) => {
  return (
    <S.Container>
      {props.items.map((item) => {
        return <SidebarItemWidget item={item} key={item.key} active={item.key === props.activeItemKey} />;
      })}
    </S.Container>
  );
};

export namespace S {
  export const Container = styled.div`
    background: ${(p) => p.theme.sidebar.background};
    width: 215px;
    height: 100%;
    user-select: none;
    border-right: 1px solid ${(p) => p.theme.sidebar.borderColor};

    a {
      text-decoration: none;
    }
  `;

  export const SidebarItem = styled.div<{ active: boolean; disabled: boolean }>`
    display: flex;
    align-items: center;
    min-height: 52px;
    background: ${(p) => (p.active ? p.theme.sidebar.backgroundActive : p.theme.sidebar.background)};
    border-bottom: 1px solid ${(p) => p.theme.sidebar.borderColor};

    &:hover {
      ${(p) =>
        !p.disabled
          ? css`
              cursor: pointer;
              color: ${p.theme.sidebar.color};
              background: ${p.theme.sidebar.backgroundHover};
            `
          : ''}
    }
  `;

  export const Label = styled.div<{ active: boolean; disabled: boolean }>`
    color: ${(p) => p.theme.sidebar.color};
    font-weight: ${(p) => (p.active ? 'bold' : 'normal')};
    font-size: 16px;
    text-decoration: none;
    padding-left: 30px;
    opacity: ${(p) => (p.disabled ? 0.3 : 1)};
  `;
}
